import React, { FC, memo, useMemo } from 'react'
import { useRouter } from 'next/router'
import {
  getNextRandomColor,
  resetRandomColors,
} from '@ucheba/utils/helpers/random-colors'
import { Container } from '@ucheba/ui/components/Container/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import { Aside } from '@ucheba/ui/components/Aside/desktop'
import { Logo } from '@ucheba/ui/components/Logo/desktop'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Banner } from '../../../Banner/desktop'
import { forAbiturients } from '../../../../routs'
import { IEventPageProps } from '../../types'
import EventsInstitution from '../../components/EventsInstitution/desktop'
import EventsContent from '../../components/EventsContent/desktop'
import EventsLeading from '../../components/EventsLeading/desktop'
import EventsLocation from '../../components/EventsLocation/desktop'
import EventsRegistration from '../../components/EventsRegistration/desktop'
import EventsAnother from '../../components/EventsAnother/desktop'
import EventsHero from '../../components/EventsHero/desktop'
import { uchebaName } from '../../constants'
import ParentFormDialog from '../../../ParentFormDialog/desktop'

const EventPageActual: FC<IEventPageProps> = (props) => {
  const { query } = useRouter()

  const {
    institution,
    name,
    content,
    speakers,
    addresses,
    description,
    branding,
    pathname,
    eventsSearchPath,
    bannerProgramTypes,
    onClickAction,
    exam,
    id,
    bannersBlock,
  } = props

  const params = useMemo(() => {
    if (query['programTypes[]']) {
      return query
    }

    if (!bannerProgramTypes) return undefined

    return {
      ...query,
      programTypes: bannerProgramTypes,
    }
  }, [query, bannerProgramTypes])

  resetRandomColors()
  const locations = addresses.map((address) => ({
    address: address.address,
    comment: address.comment,
    point: address.point,
    color: getNextRandomColor(),
  }))

  return (
    <>
      <Container>
        <Spacing spacing='xlarge' />

        <Grid as='main'>
          <GridCol uxs={24}>
            <Grid as='div'>
              <GridCol uxs={5} as='aside'>
                {institution ? (
                  <Aside indentSide='right'>
                    <EventsInstitution {...institution} />
                  </Aside>
                ) : (
                  <Aside>
                    <Logo color='blue' width='80px' isSquare />

                    <Spacing spacing='small' />

                    <Heading
                      h4={uchebaName}
                      href={forAbiturients.school.path}
                      color='blue'
                    />
                  </Aside>
                )}
              </GridCol>

              <GridCol uxs={14} as='article'>
                <EventsHero name={name} description={description} branding={branding} />

                {content && <EventsContent content={content} />}

                <Spacing spacing='xlarge' />

                {speakers && <EventsLeading speakers={speakers} />}

                {locations && <EventsLocation locations={locations} />}

                {institution && !bannersBlock && <Banner id={4} extraParams={params} />}

                <Spacing spacing='uxlarge' />
              </GridCol>

              <GridCol uxs={5} as='aside'>
                <Aside>
                  <EventsRegistration {...props} onClickAction={onClickAction} />
                </Aside>
              </GridCol>
            </Grid>

            <Grid as='div'>
              <GridCol uxs={5} as='aside' />

              <GridCol uxs={14} as='article'>
                <EventsAnother pathname={pathname} eventsSearchPath={eventsSearchPath} />
              </GridCol>

              <GridCol uxs={5} as='aside' />
            </Grid>
          </GridCol>
        </Grid>

        <Spacing spacing='uxlarge' />
      </Container>

      <ParentFormDialog exam={exam} id={id} />

      {institution && !bannersBlock && (
        <>
          <Banner id={6} extraParams={params} />
          <Banner id={14} extraParams={params} />
        </>
      )}
    </>
  )
}

export default memo(EventPageActual)
